import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

export default class extends Controller {
  static targets = ["frame"]
  static values = { src: String }

  connect() {
    this.boundLoad = this.load.bind(this)
    this.boundUnload = this.unload.bind(this)
    this.boundPrepareForCache = this.prepareForCache.bind(this)

    this.element.addEventListener("shown.bs.modal", this.boundLoad)
    this.element.addEventListener("hidden.bs.modal", this.boundUnload)
    document.addEventListener("turbo:before-cache", this.boundPrepareForCache)
  }

  disconnect() {
    this.element.removeEventListener("shown.bs.modal", this.boundLoad)
    this.element.removeEventListener("hidden.bs.modal", this.boundUnload)
    document.removeEventListener("turbo:before-cache", this.boundPrepareForCache)
    this.unload()
  }

  load() {
    if (!this.hasFrameTarget || this.frameTarget.hasAttribute("src")) return

    this.frameTarget.src = this.srcValue
  }

  unload() {
    if (!this.hasFrameTarget) return

    this.frameTarget.removeAttribute("src")
  }

  prepareForCache() {
    this.unload()
    Modal.getInstance(this.element)?.hide()
  }
}
